// extracted by mini-css-extract-plugin
export default {"timeExceededInfoContainer":"TimeExceededInfo_timeExceededInfoContainer__aynAJ"};